import httpClient from "./httpClient";
import notes from "./note.js";

export default {
  // Tours
  async getTours(includeArchives = false) {
    let params = { params: { archives: includeArchives } };
    const response = await httpClient.get(`/tours`, params);
    return response.data;
  },

  async createTour(tour) {
    const response = await httpClient.post(`/tours`, {
      ...tour
    });
    return response.data;
  },

  async getTour(tour_id) {
    const response = await httpClient.get(`/tours/${tour_id}`);
    return response.data;
  },

  async updateTour(tour) {
    const response = await httpClient.put(`/tours/${tour.id}`, {
      ...tour
    });
    return response.data;
  },

  async deleteTour(tour_id) {
    const response = await httpClient.delete(`/tours/${tour_id}`);
    return response.data;
  },

  // Tour Notes
  ...notes,

  // Departures
  async getDepartures(tour_id) {
    const response = await httpClient.get(`/tours/${tour_id}/departures`);
    return response.data;
  },

  async getFutureDepartures(tour_id) {
    const response = await httpClient.get(
      `/tours/${tour_id}/departures/future`
    );
    return response.data;
  },

  async getHistoricDepartures(tour_id) {
    const response = await httpClient.get(
      `/tours/${tour_id}/departures/historic`
    );
    return response.data;
  },

  async getDeparture(tour_id, departure_id) {
    const response = await httpClient.get(
      `/tours/${tour_id}/departures/${departure_id}`
    );
    return response.data;
  },

  async createDeparture(tour, departure) {
    const response = await httpClient.post(`/tours/${tour.id}/departures`, {
      ...departure
    });
    return response.data;
  },

  async updateDeparture(tour_id, departure) {
    const response = await httpClient.put(
      `/tours/${tour_id}/departures/${departure.id}`,
      {
        ...departure
      }
    );
    return response.data;
  },

  async deleteDeparture(tour_id, departure_id) {
    const response = await httpClient.delete(
      `/tours/${tour_id}/departures/${departure_id}`
    );
    return response.data;
  },

  // Tour Pricing
  async updatePricing(tour) {
    const response = await httpClient.put(`/tours/${tour.id}/pricing`, {
      ...tour
    });
    return response.data;
  },

  async publishPricing(tour) {
    const response = await httpClient.post(
      `/tours/${tour.id}/pricing/publish`,
      {}
    );
    return response.data;
  },

  // Tour Extra
  async getExtras(tour) {
    const response = await httpClient.get(`/tours/${tour.id}/extras`);
    return response.data;
  },

  async assignExtra(tour, args) {
    const response = await httpClient.post(`/tours/${tour.id}/extras`, {
      ...args
    });
    return response.data;
  },

  async updateExtra(tour, extra) {
    const response = await httpClient.put(
      `/tours/${tour.id}/extras/${extra.id}`,
      {
        ...extra
      }
    );
    return response.data;
  },

  async removeExtra(tour, extra) {
    const response = await httpClient.delete(
      `/tours/${tour.id}/extras/${extra.id}`
    );
    return response.data;
  },

  //Tour Guides
  async getGuides(tour) {
    const response = await httpClient.get(`/tours/${tour.id}/guides`);
    return response.data;
  },

  async assignGuide(tour, args) {
    const response = await httpClient.post(`/tours/${tour.id}/guides`, {
      ...args
    });
    return response.data;
  },

  async removeGuide(tour, guide) {
    const response = await httpClient.delete(
      `/tours/${tour.id}/guides/${guide.id}`
    );
    return response.data;
  }
};
